import React from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { isInPosDevice } from "utils"
import { Spinner } from "components"
import classes from "./CheckoutPayButtonContent.module.scss"

const CartPlaceOrderButtonContent = props => {
  const {
    sending,
    isLinkPay,
    cashTypes,
    internalDeliveryDisabled,
    deliveryServiceOutOfRange,
    snapboxQuotaionLoading
  } = props

  const [t] = useTranslation()

  const temporaryOff =
    useSelector(state =>
      state.systemSettings.temporaryOff
    )

  if (temporaryOff)
    return (
      <div className={classes["text"]}>
        {t("فروشگاه_بسته_است")}
      </div>
    )

  const deliveryOutOfRange =
    internalDeliveryDisabled ||
    deliveryServiceOutOfRange

  if (deliveryOutOfRange)
    return (
      <span className={classes["text"]}>
        {t("سفارش_خارج_از_محدوده_است")}
      </span>
    )

  const showSpinner =
    sending ||
    snapboxQuotaionLoading

  if (showSpinner) {
    return <Spinner color="white" size={18} />
  }

  if (isLinkPay) {
    return (
      <span className={classes["text"]}>
        {t("ارسال_لینک_پرداخت")}
      </span>
    )
  }

  const isPosPaymentSelected =
    cashTypes.some(cashType => cashType.isTerminal)

  const sendToPosTerminal =
    !isInPosDevice() &&
    isPosPaymentSelected

  if (sendToPosTerminal) {
    return (
      <span className={classes["text"]}>
        {t("ارسال_به_کارتخوان")}
      </span>
    )
  }

  return (
    <span className={classes["text"]}>
      {t("پرداخت")}
    </span>
  )
}

export default React.memo(CartPlaceOrderButtonContent)